export default __webpack_public_path__ + "static/media/search.147a6ed0.svg";